import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface EmailEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export const EmailEditor: React.FC<EmailEditorProps> = ({
  value,
  onChange,
  placeholder = 'Enter email content...',
}) => {
  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: [] }],
        ['link'],
        [{ color: [] }, { background: [] }],
        ['clean'],
      ],
    }),
    []
  );

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'list',
    'bullet',
    'align',
    'link',
    'color',
    'background',
  ];

  return (
    <div className="email-editor-wrapper">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        style={{
          backgroundColor: 'white',
        }}
      />
      <style>{`
        .email-editor-wrapper .ql-container {
          min-height: 300px;
          font-size: 14px;
        }
        .email-editor-wrapper .ql-editor {
          min-height: 300px;
        }
        .email-editor-wrapper .ql-editor.ql-blank::before {
          color: #9ca3af;
          font-style: normal;
        }
        .email-editor-wrapper .ql-toolbar {
          border-top: 1px solid #d1d5db;
          border-left: 1px solid #d1d5db;
          border-right: 1px solid #d1d5db;
          border-bottom: none;
          border-top-left-radius: 0.375rem;
          border-top-right-radius: 0.375rem;
          background-color: #f9fafb;
        }
        .email-editor-wrapper .ql-container {
          border-bottom: 1px solid #d1d5db;
          border-left: 1px solid #d1d5db;
          border-right: 1px solid #d1d5db;
          border-top: none;
          border-bottom-left-radius: 0.375rem;
          border-bottom-right-radius: 0.375rem;
        }
        .email-editor-wrapper .ql-stroke {
          stroke: #374151;
        }
        .email-editor-wrapper .ql-fill {
          fill: #374151;
        }
        .email-editor-wrapper .ql-picker-label {
          color: #374151;
        }
        .email-editor-wrapper .ql-toolbar button:hover,
        .email-editor-wrapper .ql-toolbar button:focus,
        .email-editor-wrapper .ql-toolbar button.ql-active {
          color: #2563eb;
        }
        .email-editor-wrapper .ql-toolbar button:hover .ql-stroke,
        .email-editor-wrapper .ql-toolbar button:focus .ql-stroke,
        .email-editor-wrapper .ql-toolbar button.ql-active .ql-stroke {
          stroke: #2563eb;
        }
        .email-editor-wrapper .ql-toolbar button:hover .ql-fill,
        .email-editor-wrapper .ql-toolbar button:focus .ql-fill,
        .email-editor-wrapper .ql-toolbar button.ql-active .ql-fill {
          fill: #2563eb;
        }
      `}</style>
    </div>
  );
};

